// components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaGithub, FaArrowUp } from 'react-icons/fa';
import './Footer.css';
import brandLogo from "../assets/images/large-log.webp";
import services from "../data/services";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <footer className="footer">
            <button className="scroll-top" onClick={scrollToTop}>
                <FaArrowUp />
            </button>

            <div className="container">
                <div className="footer-content">
                    <div className="footer-section">
                        {/* <div className="footer-logo">
                            <div className="logo-icon">GF</div>
                            <div className="logo-text">
                                <span className="logo-primary">GForce</span>
                                <span className="logo-secondary">Solutions</span>
                            </div>
                        </div> */}
                         <Link
                                    to="/"
                                    className="footer-brnad-logo"
                                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                  >
                                    <img src={brandLogo} alt="GForce Solutions Logo" className="logo-image" width="249" height="80" loading="lazy" decoding="async" />
                                  </Link>
                        <p className="footer-description">
                            Professional website development services that transform your digital presence and drive business growth.
                        </p>
                        <div className="social-links">
                            <a href="https://facebook.com" className="social-link" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                <FaFacebook />
                            </a>
                            <a href="https://twitter.com" className="social-link" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                                <FaTwitter />
                            </a>
                            <a href="https://linkedin.com" className="social-link" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                <FaLinkedin />
                            </a>
                            <a href="https://instagram.com" className="social-link" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                <FaInstagram />
                            </a>
                            <a href="https://github.com" className="social-link" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                                <FaGithub />
                            </a>
                        </div>
                    </div>

                    <div className="footer-section">
                        <h4>Services</h4>
                        <ul className="footer-links">
                            {services.slice(0, 5).map((service) => (
                                <li key={service.slug}><Link to={`/services/${service.slug}`}>{service.title}</Link></li>
                            ))}
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Quick Links</h4>
                        <ul className="footer-links">
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/services">Services</Link></li>
                            <li><Link to="/portfolio">Portfolio</Link></li>
                            <li><Link to="/process">Our Process</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Contact Info</h4>
                        <div className="contact-info">
                            <p>📞 +92 3098373032</p>
                            <p>✉️ talhagul70@gmail.com</p>
                            <p>📍 Qadari colony walton lahore</p>
                        </div>
                        <div className="newsletter">
                            <h5>Stay Updated</h5>
                            <div className="newsletter-form">
                                <input type="email" placeholder="Your email" />
                                <button className="btn">Subscribe</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {currentYear} GForce Solutions. All rights reserved.</p>
                    <div className="footer-legal">
                        <Link to="/privacy">Privacy Policy</Link>
                        <Link to="/terms">Terms of Service</Link>
                        <Link to="/cookie-policy">Cookie Policy</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;